<div
  class="logout-card"
  role="status"
  aria-live="polite"
  [style.--logout-duration]="redirectSeconds + 's'"
>
  <!-- L'anello attorno alla spunta è il countdown: si svuota nei secondi che
       mancano al rientro automatico. -->
  <div class="logout-mark">
    <svg class="logout-mark__ring" viewBox="0 0 80 80" aria-hidden="true">
      <circle class="logout-mark__track" cx="40" cy="40" r="34"></circle>
      <circle class="logout-mark__progress" cx="40" cy="40" r="34"></circle>
    </svg>
    <i class="pi pi-check" aria-hidden="true"></i>
  </div>

  <h1 class="logout-card__title">Logout effettuato con successo</h1>
  <p class="logout-card__text">
    La sessione è chiusa. Piani e carrello restano disponibili anche senza account.
  </p>

  <p class="logout-card__timer">
    Ti riportiamo ai piani tra
    <span class="logout-card__seconds">{{ secondsLeft() }}</span>
    {{ secondsLeft() === 1 ? 'secondo' : 'secondi' }}
  </p>

  <div class="logout-card__actions">
    <p-button label="Vai ai piani" styleClass="w-full" (onClick)="goToPlans()"></p-button>
    <p-button
      label="Accedi di nuovo"
      severity="secondary"
      [text]="true"
      styleClass="w-full"
      (onClick)="loginWithKeycloak()"
    ></p-button>
    <p-button
      label="Password dimenticata?"
      severity="secondary"
      [text]="true"
      size="small"
      styleClass="w-full underline"
      [routerLink]="['/', AppRoutes.AUTH, AppRoutes.AUTH_FORGOT_PASSWORD]"
      (onClick)="stopCountdown()"
    ></p-button>
  </div>
</div>
